<template>
    <div class="top-head">
        <!-- 标题 -->
        <div class="top-head-left">
            <img :src="protectEasyLogo" style="width: 44%;margin-left: -38px;">
        </div>
        <!-- 右侧 -->
        <div class="top-head-right">
          <div style="margin-right: 10px;cursor: pointer;" @click="showAIChat = true">
            <div style="height: 60px;display: flex;align-items: center;">
              <svg t="1765784198068" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="80751" width="20" height="20"><path d="M145.408 406.528l6.144 0.512c44.544 3.584 77.824 42.496 74.752 87.04-2.048 28.672-19.456 53.76-44.544 66.56l-3.584 1.536v101.376c0 3.072 1.024 5.632 2.56 7.68l1.536 1.536 2.048 1.536 297.984 167.936c3.584 2.048 7.168 2.048 9.728 1.024l2.56-1.536 296.448-167.424c3.072-1.536 5.632-4.608 6.144-8.192l0.512-2.56v-35.328c0-16.384 11.776-30.72 29.696-33.792l4.608-0.512c18.944 0 34.304 15.36 34.304 34.304v35.328c0 29.184-15.872 56.32-40.96 70.656l-296.448 167.424c-24.576 13.824-54.784 13.824-79.872 0l-297.984-167.936c-25.6-14.336-41.472-41.472-41.472-70.656v-102.912l-4.608-2.56c-26.624-15.36-42.496-44.544-40.448-75.264l0.512-6.656c5.632-39.424 39.936-69.12 80.384-69.12z m382.976-332.288l296.448 167.424c25.6 14.336 41.472 41.472 41.472 70.656v101.376l4.608 2.048c26.624 14.336 43.52 43.52 42.496 74.752l-0.512 6.656c-5.632 44.544-46.08 75.776-90.624 70.144-44.544-5.632-75.776-46.08-70.144-90.624 3.072-25.6 18.432-48.128 41.472-60.928l4.608-2.048V311.808c0-2.56-1.024-5.632-2.56-7.68l-1.536-1.536-2.048-1.536-297.472-166.912c-3.072-1.536-6.656-2.048-9.728-1.024l-2.56 1.024L184.32 302.08c-3.072 1.536-5.632 4.608-6.144 8.192v36.864c0 17.92-13.312 33.28-31.232 34.816-18.432 1.536-34.816-11.776-36.864-29.696l-0.512-4.608v-34.816c0-29.184 15.872-56.32 41.472-70.656l297.984-167.936c24.064-13.824 54.784-13.824 79.36 0zM145.408 456.704C128 455.68 113.152 468.992 112.64 486.4c-1.024 17.408 12.8 31.744 29.696 32.768h3.072c17.408-1.024 30.72-15.36 29.696-32.768-1.024-16.384-13.824-29.184-29.696-29.696z m686.08 0c-17.408-1.024-31.744 12.8-32.768 29.696s12.8 31.744 29.696 32.768h3.072c17.408-1.024 30.72-15.36 29.696-32.768-0.512-16.384-13.312-29.184-29.696-29.696z" fill="#ffffff" p-id="80752"></path><path d="M487.424 550.912H377.344l-20.48 61.44H290.816l107.008-299.52h70.656l105.984 299.52H506.88l-19.456-61.44z m-17.408-51.712l-37.376-117.76-38.4 117.76h75.776z m137.728-185.856h62.464v299.52h-62.464V313.344z" fill="#ffffff" p-id="80753"></path></svg>
            </div>
          </div>
            <div>
                <Select v-model="language" style="color: #fff;" :transfer="true" @on-change="changeLanguage(language)" :placeholder="$t('message.switchLanguage')">
                    <Option v-for="item in languageList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                <span> |</span>
            </div>
            <div>{{ $t('message.hello') }},{{currentName}} !<span> |</span></div>
            <div>{{realTime}}<span> |</span></div>
          <div>
            <Select v-model="systemType" style="color: #fff;" :transfer="true" @on-change="changeSystem" :placeholder="$t('message.switchSystem')">
              <Option v-for="item in systemList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <span> |</span>
          </div>
            <div @click="logout" style="cursor: pointer;">{{ $t('message.logout') }}<span></span></div>
        </div>
      <Modal
        v-model="showAIChat"
        title=""
        width="800"
        :mask-closable="false"
        :footer-hide="true"
      >
        <template slot="header">
          <div style="display: flex;justify-content: flex-end;margin-right: 30px;">
            <Tooltip v-if="!showHistory" class="item" effect="dark" :content="$t('aiChat.historicalConversationRecords')" placement="bottom">
              <Icon type="md-alarm" style="font-size: 18px;cursor: pointer" @click="showHistoryList" />
            </Tooltip>
            <Tooltip v-else class="item" effect="dark" :content="$t('aiChat.conversationDetails')" placement="bottom">
              <Icon type="ios-arrow-back" style="font-size: 14px;border: 1px solid #909399;border-radius: 50%;cursor: pointer" @click="closeHistory" />
            </Tooltip>
          </div>
        </template>
        <div v-if="!showHistory" class="chat-main">
          <div ref="chatBox" class="chat-container" @scroll="handleScroll">
            <!-- 欢迎信息 -->
            <div class="welcome-section">
              <div class="welcome-card">
                <div>{{ $t('aiChat.content') }}</div>
                <div>{{ $t('aiChat.questionText') }}</div>
              </div>
              <div class="question-list">
                <div v-for="(item, index) in questionList" :key="index" class="question-item" @click="askQuestion(item.content)">{{ item.content }}</div>
              </div>
            </div>
            <!-- 消息列表 -->
            <div class="message-list">
              <div v-for="(message, index) in messages" :key="index" class="message-block">
                <!-- 用户消息 -->
                <div v-if="message.sender === 'user_input'" class="user-message">
                  <div class="msg-header">
                    <div class="avatar user-avatar">
                      <svg viewBox="0 0 24 24" width="18" height="18" fill="#fff"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
                    </div>
                    <span class="sender-name">{{ $t('aiChat.user') }}</span>
                    <span class="msg-time">{{ formatTime(message.timestamp) }}</span>
                  </div>
                  <div class="msg-body user-body">{{ message.content }}</div>
                </div>
                <!-- AI消息 -->
                <div v-else class="ai-message">
                  <div class="msg-header">
                    <div class="avatar ai-avatar">
                      <svg viewBox="0 0 24 24" width="18" height="18" fill="#fff"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
                    </div>
                    <span class="sender-name">{{ $t('aiChat.assistant') }}</span>
                    <span class="msg-time">{{ formatTime(message.timestamp) }}</span>
                  </div>
                  <div class="msg-body">
                    <div v-if="message.aiLoading" class="loading-state">
                      <Icon class="loading-icon" type="ios-loading" />
                      <span>{{ $t('aiChat.thinking') }}...</span>
                    </div>
                    <template v-else>
                      <!-- 思考模块 -->
                      <div v-if="message.thinkingContent" class="thinking-block">
                        <div class="thinking-header" @click="message.showThinking = !message.showThinking">
                          <svg class="bulb-icon" viewBox="0 0 24 24" width="16" height="16"><path d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6A4.997 4.997 0 0 1 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z" fill="currentColor"/></svg>
                          <span>{{ $t('aiChat.deepThinking') }}（{{ $t('aiChat.timeSpent') }} {{ message.thinkingDuration }} {{ $t('aiChat.seconds') }}）</span>
                          <svg class="arrow-icon" :class="{ expanded: message.showThinking }" viewBox="0 0 24 24" width="16" height="16"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" fill="currentColor"/></svg>
                        </div>
                        <div v-show="message.showThinking" class="thinking-body">
                          <vue-markdown :source="getSafeMarkdown(message.thinkingContent, message.answerOver)" :breaks="true" />
                        </div>
                      </div>
                      <div class="msg-content">
                        <vue-markdown :source="getSafeMarkdown(message.content, message.answerOver)" :breaks="true" />
                      </div>
                      <div v-if="message.showLoadingText" class="loading-text">
                        <Icon class="loading-icon" type="ios-loading" />
                        <span>{{ loadingText }}</span>
                      </div>
                      <div v-if="message.answerOver" class="msg-actions">
                        <Tooltip :content="$t('aiChat.copyText')" placement="top"><span class="action-btn" @click="copyContent(message.content)"><svg viewBox="0 0 24 24" width="16" height="16"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill="currentColor"/></svg></span></Tooltip>
                        <Tooltip :content="$t('aiChat.answerAgain')" placement="top"><span class="action-btn" @click="answerAgain(index - 1)"><svg viewBox="0 0 24 24" width="16" height="16"><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" fill="currentColor"/></svg></span></Tooltip>
                        <Tooltip :content="message.like ? $t('aiChat.cancelLike') : $t('aiChat.like')" placement="top"><span class="action-btn" :class="{ active: message.like }" @click="message.like = !message.like"><svg viewBox="0 0 24 24" width="16" height="16"><path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z" fill="currentColor"/></svg></span></Tooltip>
                        <Tooltip :content="message.dislike ? $t('aiChat.cancelDislike') : $t('aiChat.dislike')" placement="top"><span class="action-btn" :class="{ active: message.dislike }" @click="message.dislike = !message.dislike"><svg viewBox="0 0 24 24" width="16" height="16"><path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z" fill="currentColor"/></svg></span></Tooltip>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 输入区域 -->
          <div class="input-section">
            <div class="input-box">
              <Input v-model="newMessage" type="textarea" :autosize="{ minRows: 1, maxRows: 4 }" :placeholder="$t('aiChat.inputPlaceholder')" @keydown.enter.exact.native="handleEnter" />
              <div class="send-btn-wrap">
                <Button v-if="!showStopIcon" class="send-btn" type="primary" shape="circle" size="small" @click="sendMessage">
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="#fff" style="margin-top: 6px"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
                </Button>
                <Button v-else class="stop-btn" type="error" shape="circle" size="small" @click="stopAnswer">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="#fff" style="margin-top: 6px"><path d="M6 6h12v12H6z"/></svg>
                </Button>
              </div>
            </div>
            <div class="input-footer">
              <Button type="text" size="small" @click="newChat">+ {{ $t('aiChat.createNewConversation') }}</Button>
            </div>
          </div>
        </div>
        <div v-else>
          <div style="font-size: 20px;font-weight: 700;">{{ $t('aiChat.historicalConversationRecords') }}</div>
          <div ref="historyBox" class="history-container" @scroll.passive="handleHistoryScroll">
            <div v-for="item in historyList" :key="item.sessionId">
              <div class="history-item">
                <div style="flex: 1;cursor: pointer;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" @click="lookChatDetails(item.sessionId)">· {{ item.title }}</div>
                <div>
                  <span>{{ item.lastUpdated }}</span>
                  <Icon type="md-close" style="cursor: pointer;font-size: 18px;margin-left: 40px" @click="deleteItem(item.sessionId)" />
                </div>
              </div>
            </div>
            <div v-if="historyLoading" class="history-loading">
              <Icon class="loading-icon" type="ios-loading" />
              <span>{{ $t('aiChat.loading') }}</span>
            </div>
            <div v-if="noMoreHistory && historyList.length > 0" class="history-no-more">
              {{ $t('aiChat.noMoreData') }}
            </div>
          </div>
        </div>
      </Modal>
    </div>
</template>
<script>
    import {setCookie, getCookie, delCookie} from '../utils/cookieUtil.js'
    import VueMarkdown from 'vue-markdown'
    import aiAssistant from "../api/aiAssistant";

    var topHead = {}
    export default {
        name: 'TopHead',
        inject: ['reload'],
        components: {
            VueMarkdown
        },
        data() {
            return {
                ourCompanyId: getCookie(global.companyId),
                userId: localStorage.getItem('userId'),
                languageList: [
                {
                    value: 'zh',
                    label: this.$t('message.chineseLabel')
                },
                {
                    value: 'en',
                    label: 'English'
                }],
                language: '',
                systemType: '',
                currentName: '',
                realTime: '',
                protectEasyLogo: require('../../static/images/silverLining.png'),
                systemList: [{
                  value: 1,
                  label: this.$t('message.managementSystem')
                }, {
                  value: 2,
                  label: 'Cloud Billing'
                }],
              showAIChat: false,
              sessionId: '',
              newMessage: '',
              messages: [],
              aiLoading: false, // AI返回内容前的Loading
              questionList: [
                { content: this.$t('aiChat.questionOne') },
                { content: this.$t('aiChat.questionTwo') },
                { content: this.$t('aiChat.questionThree') }
              ],
              showHistory: false,
              showStop: false, // 是否展示停止按钮
              historyList: [],
              showLoading: false, // 历史记录Loading
              historyLoading: false, // 历史记录加载更多Loading
              noMoreHistory: false, // 没有更多历史记录
              page: 1,
              userName: getCookie(global.cookieName),
              loadingText: '',
              showStopIcon: false,
              isUserScrolling: false, // 是否用户滑动
              thinkingTimer: null // 思考计时器

            }
        },
        mounted: function () {
            this.init()
            // 页面加载完后显示当前时间
            this.realTime = this.dealWithTime(new Date())
            // 定时刷新时间
            let _this = this
            // 定时器
            this.timer = setInterval(function () {
                _this.realTime = _this.dealWithTime(new Date()) // 修改数据date
            }, 1000)
        },
        beforeCreate: function () {
            topHead = this
        },
        methods: {
          // 格式化时间
          formatTime(timestamp) {
            if (!timestamp) return ''
            const date = new Date(timestamp)
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            return `${month}/${day} ${hours}:${minutes}`
          },
          // 处理流式输出的Markdown内容，防止未完成的标题影响渲染
          getSafeMarkdown(content, isComplete) {
            if (!content) return ''
            if (isComplete) return content
            // 流式输出时，检查最后一行是否是未完成的标题
            const lines = content.split('\n')
            const lastLine = lines[lines.length - 1]
            // 如果最后一行以 # 开头但没有内容，或者是未完成的格式标记
            if (/^#{1,6}\s*$/.test(lastLine) || /^[-*]\s*$/.test(lastLine) || /^\d+\.\s*$/.test(lastLine)) {
              // 在最后一行前添加换行，让未完成的标记单独成行
              return content + '\n\u200B'
            }
            // 在末尾添加零宽空格，防止标题样式延续
            return content + '\u200B'
          },
          // 处理回车发送
          handleEnter(e) {
            if (!e.shiftKey) {
              e.preventDefault()
              this.sendMessage()
            }
          },
          // 启动思考计时器
          startThinkingTimer() {
            this.stopThinkingTimer() // 先清除已有的计时器
            this.thinkingTimer = setInterval(() => {
              const lastMsg = this.messages[this.messages.length - 1]
              if (lastMsg && lastMsg.thinkingStartTime && lastMsg.showLoadingText) {
                lastMsg.thinkingDuration = Math.round((Date.now() - lastMsg.thinkingStartTime) / 1000)
              }
            }, 1000)
          },
          // 停止思考计时器
          stopThinkingTimer() {
            if (this.thinkingTimer) {
              clearInterval(this.thinkingTimer)
              this.thinkingTimer = null
            }
          },
          load() {
      this.page++
      this.getHistoryList()
    },
    // 复制AI回复文案
    copyContent(e) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(e)
          .then(() => this.$Message.success(this.$t('message.copySuccessfully')))
          .catch(() => this.$Message.error(this.$t('message.copyFailed')))
      } else {
        // 兼容旧版浏览器
        const textarea = document.createElement('textarea')
        textarea.value = e
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$Message.success(this.$t('message.copySuccessfully'))
      }
    },
    // 重新回答
    answerAgain(i) {
      this.messages.push({ sender: 'user_input', content: this.messages[i].content, timestamp: Date.now() })
      this.sendMessage(this.messages[i].content, 1)
    },
    scrollToBottom() {
      const chatBox = this.$refs.chatBox
      if (chatBox) {
        chatBox.scrollTop = chatBox.scrollHeight
      }
    },
    async askQuestion(e) {
      this.messages.push({ sender: 'user_input', content: e, timestamp: Date.now() })
      await this.sendMessage(e, 1)
    },
    // 创建新的对话
    newChat() {
      this.sessionId = ''
      this.messages = []
      this.showStop = false
      this.showStopIcon = false
    },
    // 滑动事件
    handleScroll() {
      const container = this.$refs.chatBox
      const { scrollTop, clientHeight, scrollHeight } = container
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 50 // 50px 容差

      if (!isAtBottom) {
        this.isUserScrolling = true // 用户向上滚动
      } else {
        this.isUserScrolling = false // 用户回到底部
      }
    },
    // 停止回答
    stopAnswer() {
      const data = {
        sessionId: this.sessionId,
        companyId: this.ourCompanyId,
        userId: this.userId,
        application: 'SME',
        roleName: this.userName
      }
      aiAssistant.stopStream(this.sessionId, data).then(() => {
        this.showStop = false
        this.showStopIcon = false
        this.stopThinkingTimer()
        if (this.messages.length > 0) {
          const lastMsg = this.messages[this.messages.length - 1]
          lastMsg.answerOver = true
          lastMsg.showLoadingText = false
        }
      }).catch(() => {
        // 请求失败也要重置状态，避免卡死
        this.showStop = false
        this.showStopIcon = false
        this.stopThinkingTimer()
      })
    },
    closeHistory() {
      this.showHistory = false
      this.page = 1
      this.noMoreHistory = false
    },
    // 查看历史聊天记录
    showHistoryList() {
      this.page = 1
      this.noMoreHistory = false
      this.showHistory = true
      this.getHistoryList()
    },
    // 历史记录滚动事件
    handleHistoryScroll(e) {
      const container = e.target || this.$refs.historyBox
      if (!container) return
      const { scrollTop, clientHeight, scrollHeight } = container
      // 滚动到底部时加载更多（距离底部50px时触发）
      if (scrollHeight - scrollTop - clientHeight < 50) {
        this.loadMoreHistory()
      }
    },
    // 加载更多历史记录
    loadMoreHistory() {
      if (this.historyLoading || this.noMoreHistory) return
      this.page++
      this.getHistoryList()
    },
    getHistoryList() {
      if (this.page === 1) {
        this.showLoading = true
        this.historyList = []
        this.noMoreHistory = false
      } else {
        this.historyLoading = true
      }
      const data = {
        companyId: this.ourCompanyId,
        userId: this.userId,
        application: 'SME',
        roleName: this.userName,
        limit: 10,
        page: this.page
      }
      aiAssistant.getChatHistories(data).then(res => {
        const items = res.data.data.historyItems || []
        this.historyList.push(...items)
        // 如果返回的数据少于limit，说明没有更多数据了
        if (items.length < 10) {
          this.noMoreHistory = true
        }
      }).finally(() => {
        this.showLoading = false
        this.historyLoading = false
      })
    },
    // 查看聊天详情
    lookChatDetails(id) {
      this.showHistory = false
      this.page = 1
      const data = {
        sessionId: id,
        companyId: this.ourCompanyId,
        userId: this.userId,
        application: 'SME'
      }
      aiAssistant.getChatDetails(id, data).then(res => {
        this.messages = res.data.data.history
        this.sessionId = id
      })
    },
    // 删除聊天记录
    deleteItem(id) {
      this.$Modal.confirm({
        title: this.$t('Bill.ResourceOptimization.prompt'),
        content: this.$t('aiChat.areYouSureToDeleteThisChatRecord'),
        okText: this.$t('BillingServices.confirm'),
        cancelText: this.$t('BillingServices.cancel'),
        onOk: () => {
          const data = {
            sessionId: id,
            companyId: this.ourCompanyId,
            userId: this.userId,
            application: 'SME'
          }
          aiAssistant.deleteChatHistory(id, data).then(() => {
            this.$Message.success(this.$t('resourceLifecycle.response.deleteSuccess'))
            this.page = 1
            this.getHistoryList()
          })
        }
      })
    },
    // 发送消息
    async sendMessage(e, i) {
      if (this.showStop) return
      // 非预设问题时，先检查空消息再设置 showStop
      if (i !== 1 && this.newMessage.trim() === '') return
      const data = {
        content: i === 1 ? e : this.newMessage,
        companyId: this.ourCompanyId,
        userId: this.userId,
        application: 'SME',
        sessionId: this.sessionId,
        roleName: this.userName
      }
      this.showStop = true
      if (i !== 1) {
        // 添加用户消息
        this.messages.push({ sender: 'user_input', content: this.newMessage, timestamp: Date.now() })
        this.newMessage = ''
      }
      this.messages.push({
        sender: 'ai_output',
        content: '',
        aiLoading: true,
        answerOver: false,
        showLoadingText: false,
        like: false,
        dislike: false,
        thinkingContent: '',
        thinkingDuration: 0,
        thinkingStartTime: null,
        showThinking: false,
        timestamp: Date.now()
      })
      // 发送后立即滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom()
      })
      const response = await fetch(process.env.API_ROOT + '/sme/api/ai/sessions', {
        method: 'POST',
        headers: {
          'Authorization': getCookie("Authorization"),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      await this.handleStreamResponse(response)
    },
    async handleStreamResponse(response) {
      const reader = response.body.getReader()
      const decoder = new TextDecoder()

      let buffer = ''
      let messageContent = ''

      try {
        while (true) {
          const { done, value } = await reader.read()
          if (done) break

          buffer += decoder.decode(value, { stream: true })
          const lines = buffer.split('\n')
          buffer = lines.pop() || '' // 保留最后一个不完整的行
          if (this.messages.length <= 0) {
            return
          }
          this.showStopIcon = true
          this.messages[this.messages.length - 1].aiLoading = false
          for (const line of lines) {
            if (line.startsWith('data: ')) {
              const data = line.slice(6).trim()

              if (data === '[DONE]') {
                this.showStop = false
                this.showStopIcon = false
                this.messages[this.messages.length - 1].answerOver = true
                this.messages[this.messages.length - 1].showLoadingText = false
                this.stopThinkingTimer() // 停止思考计时器
                return
              }

              try {
                const chunk = JSON.parse(data)
                if (chunk.session_id) {
                  this.sessionId = chunk.session_id
                }
                // 处理聊天完成块
                if (chunk.choices && chunk.choices[0]) {
                  const choice = chunk.choices[0]
                  const delta = choice.delta

                  if (delta) {
                    // 处理文本内容
                    if (delta.status === 1 && delta.content) {
                      if (this.messages[this.messages.length - 1].showLoadingText) {
                        this.messages[this.messages.length - 1].showLoadingText = false
                        // 停止思考计时器
                        this.stopThinkingTimer()
                        messageContent += '\n'
                      }
                      messageContent += delta.content
                      this.messages[this.messages.length - 1].content = messageContent
                    }
                    if ((delta.status === 0 || delta.status === 2) && delta.content) {
                      this.loadingText = this.$t('aiChat.thinkText')
                      this.messages[this.messages.length - 1].showLoadingText = true
                      // 记录思考开始时间并启动计时器
                      if (!this.messages[this.messages.length - 1].thinkingStartTime) {
                        this.messages[this.messages.length - 1].thinkingStartTime = Date.now()
                        this.startThinkingTimer()
                      }
                      if (delta.status === 2) {
                        // 累积思考内容
                        this.messages[this.messages.length - 1].thinkingContent += delta.content
                      }
                    }
                  }
                }
              } catch (e) {
                console.warn('Failed to parse chunk:', data, e)
              }
            }
          }
          if (!this.isUserScrolling) {
            this.scrollToBottom()
          }
        }
      } catch (error) {
        console.error('Stream reading error:', error)
      } finally {
        // 无论流式响应如何结束，都确保重置状态，避免输入框无法发送
        this.showStop = false
        this.showStopIcon = false
        this.stopThinkingTimer()
        if (this.messages.length > 0) {
          const lastMsg = this.messages[this.messages.length - 1]
          if (lastMsg.sender === 'ai_output' && !lastMsg.answerOver) {
            lastMsg.aiLoading = false
            lastMsg.answerOver = true
            lastMsg.showLoadingText = false
          }
        }
      }
    },
            //localStorage 存储数组对象的方法
            saveObjArr: function (name, data) {
                localStorage.setItem(name, JSON.stringify(data))
            },
            // 中英文切换
            changeLanguage(language) {
                if (this.language == "zh") {
                    localStorage.setItem('locale', 'zh');
                    this.$i18n.locale = localStorage.getItem('locale'); //关键语句
                    this.$Message.success(this.$t('message.switchSuccess'));
                } else if (this.language == "en") {
                    localStorage.setItem('locale', 'en')
                    this.$i18n.locale = localStorage.getItem('locale'); //关键语句
                    this.$Message.success(this.$t('message.switchSuccess'));
                }
                this.switchLanguage();
                this.reload();
            },

            switchLanguage: function () {
                var userDTO = {
                    'language': this.language == "zh" ? 0 : 1
                };

                this.$api.user.changeLanguage(userDTO)
                .then(res => {
                    // todo 后期待优化
                    window.localStorage.removeItem('router');
                    this.$api.security.userMenu("userName", getCookie(global.cookieName))
                    .then(res => {
                        this.getRouter = res.data;
                        this.saveObjArr('router', this.getRouter) //存储路由到localStorage
                        window.location.reload();
                        if (this.getRouter[0].type == undefined) {
                            this.$router.replace(this.getRouter[0].path);
                        } else {
                            this.$router.replace(this.getRouter[0].children[0].path);
                        }
                    });
                })
            },

            init: function (userName) {
                var isCookie = document.cookie.indexOf(global.cookieName)
                if (isCookie != -1 && userName != undefined && getCookie(global.cookieName) != '') {
                    // cookie不为空，并且是从登录那里来的时候
                    topHead.currentName = userName
                } else if (getCookie(global.cookieName) != '') {
                    // cookie不为空的时候，并且是原地刷新的时候(这里，直接改数据没办法改变的，因为用户是不可能直接改数据库的)
                    topHead.currentName = getCookie(global.cookieName)
                }
            },
            // 登出用户
            logout: function () {
                var userName = getCookie(global.cookieName)
                this.$api.user.logout('username', this.currentName)
                .then(res => {
                    delCookie(global.cookieName)
                    delCookie(global.companyId)
                    delCookie('admin')
                    delCookie('Authorization')
                    //删除动态路由
                    localStorage.removeItem('router');
                    //删除权限数组
                    localStorage.removeItem('permissionsList');
                    localStorage.clear();
                    // 如果是冠闵点击退出后 跳转到sso登录页
                    if(this.ourCompanyId==1){
                        // window.location.href = `${global.SSO_PORTAL}/sso/index.html#/login`
                      window.location.href = `${global.SSO_PORTAL}/cmc/#/login`
                    }else{
                        window.location.reload();
                    }
                })
            },
            //切换系统
            changeSystem: function () {
                if (this.systemType === 1) {
                  this.$api.user.canChangeSystem({ destination: 'cmc' }).then(res => {
                    if (res.data.canChange === 1) {
                      delCookie(global.cookieName)
                      delCookie('admin')
                      //删除动态路由
                      localStorage.removeItem('router');
                      //删除权限数组
                      localStorage.removeItem('permissionsList');
                      // localStorage.clear();
                      const companyId = localStorage.getItem('companyId')
                      if (companyId === '1') {
                        window.location.href = `${process.env.SSO_PORTAL}/cmc/#/home/companyManage`
                      } else {
                        window.location.href = `${process.env.SSO_PORTAL}/cmc/#/home/userManage`
                      }
                    } else {
                      this.$Message.error(this.$t('message.noPermission'))
                    }
                  })
                } else {
                  this.$api.user.canChangeSystem({ destination: 'cfm' }).then(res => {
                    if (res.data.canChange === 1) {
                      const data = {
                        companyId: res.data.companyId,
                        token: res.data.token,
                        userId: res.data.userId,
                        name: res.data.userName,
                        locale: localStorage.getItem('locale')
                      }
                      window.location.href = `${process.env.CFM_PORTAL}/cfm/#/loading?companyId=${data.companyId}&userId=${data.userId}&token=${data.token}&name=${data.name}&locale=${data.locale}`
                    } else {
                      this.$Message.error(this.$t('message.noPermission'))
                    }
                  })
                }
            },
            // 实时显示当前时间
            dealWithTime: function (data) {
                let formatDateTime
                let Y = data.getFullYear()
                let M = data.getMonth() + 1
                let D = data.getDate()
                let H = data.getHours()
                let Min = data.getMinutes()
                let S = data.getSeconds()
                let W = data.getDay()
                H = H < 10 ? ('0' + H) : H
                Min = Min < 10 ? ('0' + Min) : Min
                S = S < 10 ? ('0' + S) : S
                switch (W) {
                case 0:
                W = this.$t('message.week.sun')
                break
                case 1:
                W = this.$t('message.week.mon')
                break
                case 2:
                W = this.$t('message.week.tue')
                break
                case 3:
                W = this.$t('message.week.wed')
                break
                case 4:
                W = this.$t('message.week.thu')
                break
                case 5:
                W = this.$t('message.week.fri')
                break
                case 6:
                W = this.$t('message.week.sat')
                break
                default:
                break
                }

                formatDateTime = Y + '-' + M + '-' + D + ' ' + H + ':' + Min + ':' + S
                return formatDateTime
            },
            destroyed: function () {
                if (this.timer) {
                    clearInterval(this.timer)
                }
                this.stopThinkingTimer()
            }
        }
    }
</script>
<style scoped>
    .top-head {
        position: fixed;
        left: 0px;
        top: 0px;
        right: 0;
        height: 64px;
        background-color: #2b3245;
        overflow: hidden;
    }
    .top-head-left {
        float: left;
        font-size: 18px;
        color: #fff;
        text-align: center;
        width: 159px;
        line-height: 49px;
    }
    .top-head-right {
        min-width: 261px;
        float: right;
        color: #fff;
        line-height: 60px;
    }
    .top-head-right > div {
        float: left;
    }
    .top-head-right span {
        margin-right: 10px;
        margin-left: 5px;
    }
    .top-head-right >>> .ivu-select-selection {
        background: transparent;
        border: 0;
        box-shadow: none;
    }
    .top-head-right >>> .ivu-select-selected-value {
        color: #fff;
    }
    .top-head-right >>> .ivu-select-arrow {
        position: absolute;
        top: 50%;
        right: 8px;
        line-height: 1;
        transform: translateY(-50%);
        font-size: 14px;
        color: #808695;
        transition: all .2s ease-in-out;
    }
    .top-head-right >>> .ivu-select-placeholder {
        color: #fff;
    }

    /* 聊天主体 */
    .chat-main {
      display: flex;
      flex-direction: column;
      height: 500px;
    }

    .chat-container {
      flex: 1;
      padding: 16px;
      overflow-y: auto;
      background-color: #fff;
    }

    .chat-container::-webkit-scrollbar {
      width: 6px;
    }

    .chat-container::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }

    /* 欢迎区域 */
    .welcome-section {
      padding: 20px 0;
    }

    .welcome-card {
      padding: 16px 20px;
      background-color: #f9f9f9;
      border-radius: 8px;
      color: #666;
      font-size: 14px;
      line-height: 1.6;
      margin-bottom: 20px;
    }

    .question-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .question-item {
      padding: 12px 16px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      cursor: pointer;
      font-size: 14px;
      color: #333;
      transition: all 0.2s;
    }

    .question-item:hover {
      border-color: #1890ff;
      background-color: #f0f7ff;
    }

    /* 消息列表 */
    .message-list {
      display: flex;
      flex-direction: column;
      gap: 24px;
    }

    .message-block {
      padding-bottom: 16px;
      border-bottom: 1px solid #f0f0f0;
    }

    .message-block:last-child {
      border-bottom: none;
    }

    /* 消息头部 */
    .msg-header {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
    }

    .avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
    }

    .user-avatar {
      background-color: #52c41a;
    }

    .ai-avatar {
      background-color: #fa8c16;
    }

    .sender-name {
      font-weight: 600;
      font-size: 14px;
      color: #333;
    }

    .msg-time {
      margin-left: 10px;
      font-size: 12px;
      color: #999;
    }

    /* 消息体 */
    .msg-body {
      padding-left: 42px;
    }

    .user-body {
      color: #333;
      font-size: 14px;
      line-height: 1.6;
    }

    .loading-state {
      display: flex;
      align-items: center;
      color: #999;
      font-size: 14px;
    }

    .loading-state .loading-icon {
      margin-right: 8px;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .loading-icon {
      animation: spin 1s linear infinite;
    }

    .msg-content {
      font-size: 14px;
      line-height: 1.7;
      color: #333;
      word-break: break-word;
    }

    /* Markdown 表格样式 */
    .msg-content >>> table {
      border-collapse: collapse;
      width: 100%;
      margin: 12px 0;
      font-size: 13px;
    }

    .msg-content >>> table th,
    .msg-content >>> table td {
      border: 1px solid #ddd;
      padding: 8px 12px;
      text-align: left;
    }

    .msg-content >>> table th {
      background-color: #f5f5f5;
      font-weight: 600;
    }

    .msg-content >>> table tr:nth-child(even) {
      background-color: #fafafa;
    }

    .msg-content >>> table tr:hover {
      background-color: #f0f7ff;
    }

    .loading-text {
      display: flex;
      align-items: center;
      margin-top: 8px;
      color: #999;
      font-size: 13px;
    }

    .loading-text .loading-icon {
      margin-right: 6px;
    }

    /* 思考模块 */
    .thinking-block {
      margin-bottom: 12px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      background-color: #f5f5f5;
      overflow: hidden;
    }

    .thinking-header {
      display: flex;
      align-items: center;
      padding: 10px 14px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
    }

    .bulb-icon {
      margin-right: 8px;
      color: #666;
    }

    .arrow-icon {
      margin-left: auto;
      color: #999;
      transition: transform 0.2s;
    }

    .arrow-icon.expanded {
      transform: rotate(90deg);
    }

    .thinking-body {
      padding: 12px 14px 12px 38px;
      font-size: 13px;
      color: #666;
      line-height: 1.6;
      max-height: 200px;
      overflow-y: auto;
      border-top: 1px solid #e0e0e0;
      background-color: #fafafa;
    }

    /* 操作按钮 */
    .msg-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 12px;
      padding-top: 8px;
    }

    .action-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      border-radius: 4px;
      cursor: pointer;
      color: #999;
      transition: all 0.2s;
    }

    .action-btn:hover {
      background-color: #f0f0f0;
      color: #666;
    }

    .action-btn.active {
      color: #1890ff;
    }

    /* 输入区域 */
    .input-section {
      padding: 12px 16px;
      border-top: 1px solid #f0f0f0;
      background-color: #fafafa;
    }

    .input-box {
      display: flex;
      align-items: flex-end;
      gap: 10px;
      padding: 10px 12px;
      background-color: #fff;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
    }

    .input-box >>> .ivu-input {
      border: none;
      box-shadow: none;
      resize: none;
    }

    .input-box >>> .ivu-input:focus {
      box-shadow: none;
    }

    .send-btn-wrap {
      flex-shrink: 0;
    }

    .send-btn, .stop-btn {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .input-footer {
      margin-top: 8px;
    }

    .history-container {
      height: 380px;
      margin-top: 20px;
      overflow-y: auto;
    }

    .history-container::-webkit-scrollbar {
      width: 6px;
    }

    .history-container::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }

    .history-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      border-bottom: 1px solid #cccccc;
    }

    .history-loading {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      color: #999;
      font-size: 13px;
    }

    .history-loading .loading-icon {
      margin-right: 6px;
    }

    .history-no-more {
      text-align: center;
      padding: 16px;
      color: #999;
      font-size: 13px;
    }

    /* 折叠动画 */
    .collapse-enter-active, .collapse-leave-active {
      transition: all 0.3s ease;
      overflow: hidden;
    }

    .collapse-enter, .collapse-leave-to {
      max-height: 0;
      opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/TopHead.vue